import { createSlice } from "@reduxjs/toolkit";
import { User } from "../../firebase/users";
import { login, logOut, register, socioLogin, updateProfile } from "./authThunk";

interface AuthState {
    processing: boolean;
    isAuth: boolean;
    user: User | null;
}

const initialState: AuthState = {
    processing: false,
    isAuth: false,
    user: null,
};

const slice = createSlice({
    name: "auth",
    initialState,
    reducers: {},
    extraReducers(builder) {
        builder
            .addCase(register.pending, state => {
                state.processing = true;
            })
            .addCase(register.fulfilled, (state, action) => {
                state.processing = false;
                state.isAuth = true;
                state.user = action.payload;
            })
            .addCase(register.rejected, state => {
                state.processing = false;
                state.isAuth = false;
            })
            .addCase(login.pending, state => {
                state.processing = true;
            })
            .addCase(login.fulfilled, (state, action) => {
                state.processing = false;
                state.isAuth = true;
                state.user = action.payload;
            })
            .addCase(login.rejected, state => {
                state.processing = false;
                state.isAuth = false;
            })
            .addCase(socioLogin.fulfilled, (state, action) => {
                state.isAuth = true;
                state.user = action.payload;
            })
            .addCase(logOut.fulfilled, state => {
                state.isAuth = false;
                state.user = null;
                state.processing = false;
            })
            .addCase(updateProfile.pending, state => {
                state.processing = true;
            })
            .addCase(updateProfile.fulfilled, (state, action) => {
                state.processing = false;
                state.user = { ...state.user, ...action.payload };
            })
            .addCase(updateProfile.rejected, state => {
                state.processing = false;
            });
    },
});

const { reducer } = slice;

export default reducer;
